import React, {useState, useEffect} from "react";
import Container from "@material-ui/core/Container";
import Title from "../dashboard/Title";
import Button from "@material-ui/core/Button";
import UserService from "../../services/user.service";
import {logOut} from "../../helpers/logout";
import {NotificationManager} from 'react-notifications';
import Paper from "@material-ui/core/Paper";
import TextInput from "../form/input/TextInput";
import AuthService from "../../services/auth.service";
import {TextField} from "@material-ui/core";
import Popup from "../presentation/Popup";
import ActionButton from "../form/input/ActionButton";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import Grid from "@material-ui/core/Grid";
import {useDashboardStyles} from "./dashboardStyles";
import {getAccess} from "../../helpers/permissions";

export default function DefinedTexts(props) {
    const classes = useDashboardStyles();
    const access = getAccess();

    const [values, setValues] = useState({
        default_signature_place: '',
        important_contacts: '',
        what_next: ''
    });

    const [editValues, setEditValues] = useState({
        default_signature_place: '',
        important_contacts: '',
        what_next: ''
    });

    const currentUser = AuthService.getCurrentUser();

    const [show, setShow] = useState(false);

    const handleChange = (event) => {
        const {name, value} = event.target;
        setEditValues({...editValues, [name]: value});
    }

    useEffect(() => {
        UserService.getUser(currentUser.id).then(
            (response) => {
                if (response.data.defined_texts) {
                    setValues(response.data.defined_texts);
                    setEditValues(response.data.defined_texts);
                }
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
            }
        );
    }, [currentUser.id, props]);

    const handleCreate = (e) => {
        e.preventDefault();

        UserService.createDefinedTexts(editValues).then(
            (defTexts) => {
                setValues(defTexts.data);
                setShow(false);
                NotificationManager.success('Preddefinované texty boli upravené.', 'Upravené', 5000);
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                } else {
                    NotificationManager.error('Došlo k neočakávanej chybe. Skúste neskôr alebo kontaktujte podporu.', 'Chyba', 5000);
                }
            }
        );
    };

    return (
        <Container maxWidth="lg" className={classes.pageContainer}>
            <Paper className={classes.paper} elevation={0}>
                <div className={classes.sectionHeader}>
                    <div>
                        <Title>Preddefinované texty</Title>
                    </div>
                    {access.write && <div className={classes.sectionToolbar}>
                        <ActionButton color="primary">
                            <Tooltip title="Upraviť preddefinované texty">
                                <EditIcon
                                    fontSize="small"
                                    onClick={() => {
                                        setShow(true);
                                        setEditValues(values);
                                    }}
                                />
                            </Tooltip>
                        </ActionButton>
                    </div>}
                </div>

                <div className={classes.detailView}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <TextField
                                id="default_signature_place"
                                label="Prednastavené miesto podpisu"
                                multiline
                                value={values.default_signature_place || ''}
                                InputProps={{readOnly: true}}
                                fullWidth
                            />
                            <TextField
                                id="important_contacts"
                                label="Doležité kontakty (informačný list pohrebu)"
                                multiline
                                value={values.important_contacts || ''}
                                InputProps={{readOnly: true}}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                id="what_next"
                                label="Nasledujúce informačné kroky (informačný list pohrebu)"
                                multiline
                                value={values.what_next || ''}
                                InputProps={{readOnly: true}}
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                </div>

                <Popup
                    title={'Úprava preddefinovaných textov'}
                    openPopup={show}
                    setOpenPopup={setShow}
                    actions={
                        <Button
                            variant="contained"
                            type="submit"
                            form="defined-texts-form"
                            className={classes.primaryAction}
                        >
                            Uložiť zmeny
                        </Button>
                    }
                >
                    <form id="defined-texts-form" autoComplete='off' onSubmit={handleCreate}>
                        <div className={classes.formField}>
                            <TextInput
                                label="Prednastavené miesto podpisu"
                                name={'default_signature_place'}
                                value={editValues.default_signature_place}
                                onChange={handleChange}
                                fullWidth
                            />
                        </div>
                        <div className={classes.formField}>
                            <TextInput
                                label="Doležité kontakty (informačný list pohrebu)"
                                name={'important_contacts'}
                                value={editValues.important_contacts}
                                onChange={handleChange}
                                multiline
                                rows={5}
                                fullWidth
                            />
                        </div>
                        <div className={classes.formField}>
                            <TextInput
                                label="Nasledujúce informačné kroky (informačný list pohrebu)"
                                name={'what_next'}
                                value={editValues.what_next}
                                onChange={handleChange}
                                multiline
                                rows={5}
                                fullWidth
                            />
                        </div>
                    </form>
                </Popup>
            </Paper>
        </Container>
    );
}
